// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getAudits} from '../../shared/repositories';
import {getStore} from '../../../store-factory';
import {postSkipAudit} from '../../../tcsm/shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updateSkipAudit = audit =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const {dealers} = getStore().getState().tcsm.audits.dealerHierarchyFacet;

            audit.isSkippedAudit = true;

            await postSkipAudit(audit);

            successAlertBar(translate('SKIP_AUDIT_SUCCESS'));

            const accountsArray = typeof dealers === 'string' ? [dealers] : dealers;
            const data = await getAudits(accountsArray);

            dispatch({
                data,
                type: actions.UPDATE_TCSM_AUDIT_LIST
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/audits/action-creators/update-skip-audit.js